export default {
  locations: [
    {
      id: "shpp",
      address: "Ш++, пер. Васильевский 10, 5й этаж",
      clientsIds: [1, 2]
    }
  ]
};
